import Dexie from 'dexie';

/**
 * Database configuration using Dexie for the Product - Lookup Block.
 */

const db = new Dexie( 'ProductDatabase' );
const tableDefinitions = {};

AcProductLookupBlock.db.forEach( def => {
	const countryCode = Object.keys( def )[ 0 ];
	tableDefinitions[ `${ countryCode }_productInventory` ] = def[ countryCode ];
	tableDefinitions[ `${ countryCode }_settings` ] = 'key, value';
	tableDefinitions[ `${ countryCode }_headers` ] = '++id, name';
} );

db.version( 1 ).stores( tableDefinitions );

export default db;
